
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class FormattedTextLight extends Vue {
  @Prop() description!: string;
}
